import { FC } from "react";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useRef } from "react";
import { useAppDispatch } from "src/hooks";
import { useAppSelector } from './../../hooks';
import { repairsData, repairsDataDelete, repairsDataDeleteByID } from './../../features/repairs/repairsActions';
import { RepairsTable } from '../../components/jsx_components/RepairsTable';
import Button from "@mui/material/Button";
import { Autocomplete, Box, CircularProgress, IconButton, InputAdornment, TextField, ThemeProvider, createTheme } from "@mui/material";
import { green } from "@mui/material/colors";
import { RepairsTablePagination } from "src/components/jsx_components/RepairsTablePagination";
import SearchIcon from "@mui/icons-material/Search";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { ruRU } from "@mui/material/locale";


export const RepairRequestsPage: FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const theme = createTheme(ruRU);

  const { dataRepairs } = useAppSelector(state => state.repairs);

  const [loading, setLoading] = React.useState(true);

  const [selectedRows, setSelectedRows] = React.useState<number[]>([]);

  useEffect(() => {
    // callback function to call when event triggers
    const onPageLoad = () => {

      console.log('page loaded');

      setTimeout(() => {
        setLoading(false);
      }, 1000);

      // do something else
    };

    // Check if the page has already loaded
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      // Remove the event listener when component unmounts
      return () => { window.removeEventListener('load', onPageLoad); }
    }
  }, []);



  //Клиенты и контакты 1
  const childToParent = (childdata1: number[]) => {

    setSelectedRows(childdata1);

  };

  /*useEffect(() => {
    dispatch(repairsData());
  }, [dispatch]);
*/

  return (
    <div className="main-page">

      {(loading) && (
        <Box>
          <CircularProgress
            size={200}
            sx={{
              color: green[500],
              position: 'absolute',
              top: '40%',
              left: '50%',
              width: '100px',
              height: '100px',
            }}
          />
        </Box>
      )}



      <React.Fragment>
        <div>
          {/*<RepairsTable childToParent={childToParent} dataRows={dataRepairs?.payload} />*/}

          <ThemeProvider theme={theme}>

            <TextField
              label="Поиск по запросам"

              sx={{
                  width: '500px',

              }}

              InputProps={{
                startAdornment: (
                  <InputAdornment
                  position="start"
                  onClick={() => {                   
                  }}
                  >
                    <IconButton>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            


          </ThemeProvider>




          <br></br>
          {<RepairsTablePagination childToParent={childToParent} />}

        </div>


        <Button
          sx={{

            color: "white",
            backgroundColor: "#16b8f3",
            orderTop: 20,
            left: 210,
            height: 40,
            position: "absolute",
            // transform: "translateY(-50%)",

            "&:hover": {
              backgroundColor: "#12a8df",
            },
          }}
          variant="contained"
          onClick={() => {
            //navigate('/create-requests');

            let currentRowId = 0;

            navigate(`/request/${currentRowId}`);

          }}
        >
          Создать запрос
        </Button>


        {selectedRows.length === 1 ?
          <Button
            sx={{

              color: "white",
              backgroundColor: "#16b8f3",
              orderTop: 20,
              left: 380,
              height: 40,
              position: "absolute",
              // transform: "translateY(-50%)",

              "&:hover": {
                backgroundColor: "#12a8df",
              },
            }}
            variant="contained"
            onClick={() => {
              //navigate('/create-requests');

              let currentRowId = selectedRows[0];

              navigate(`/request/${currentRowId}`);

            }}
          >
            Редактировать запрос
          </Button> : ""
        }


        {selectedRows.length === 1 ?
          <Button
            sx={{

              color: "white",
              backgroundColor: "#16b8f3",
              orderTop: 20,
              left: 607,
              height: 40,
              position: "absolute",
              // transform: "translateY(-50%)",

              "&:hover": {
                backgroundColor: "#12a8df",
              },
            }}
            variant="contained"
            onClick={() => {

              let currentRowId = selectedRows[0];

              dispatch(repairsDataDeleteByID(currentRowId)).then(() => {
                dispatch(repairsData());

              });

            }}
          >
            Удалить запрос
          </Button> : ""
        }




      </React.Fragment>




    </div>




  )
}